module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/2EfKHQ/tc-custom/9781460301562.jpg?1706382904378",
      "alt": "This image is the cover for the book Devil's Footprints"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Devil's Footprints\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The footprints were etched in the snow for miles, passing through walls and crossing riversappearing on the other side as though no barrier could stop them.")]), _c('br'), _c('br'), _vm._v("In 1922 a farmer in Adamant, Arkansas, awakes to a noise on his roof and finds his snow-blanketed yard marked with thousands of cloven footprints. The prints vanish with the melting snowonly to reappear seventy years later near the gruesome killing of Rachel DeLaune."), _c('br'), _c('br'), _vm._v("Years after her sister’s unsolved murder, New Orleans tattoo artist Sarah DeLaune is haunted by the mysteries of her past. Sarah has always believed that her sister was killed by a man named Ashe Cain. But no one else had ever seen Ashe. He had “appeared” to Sarah when she needed a friend the most, only to vanish on the night of her sister’s murder. The past bleeds into the present when two mutilated bodies are found near Sarah’s home, the crime scene desecrated by cloven footprints.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Stevens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Stevens is an award-winning author of over fifty novels. Born and raised in the rural south, she now resides in Houston, Texas.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0